import sortAlphabetical from "helpers/sortAlphabetical";
import { Detail } from "types/datacontrol.types";

function sortByPropertyName(category: number, details: Detail[]) {
  if ([3, 4, 7, 8].includes(category) && details.length > 0) {
    return details
      .slice()
      .sort((a, b) => sortAlphabetical(a.propertyName, b.propertyName));
  }

  return [];
}

export default sortByPropertyName;
